import { List as ChakraList, ListProps as ChakraListProps } from '@chakra-ui/react';
import React from 'react';

export type ListProps = ChakraListProps;
export default function List(props: ChakraListProps): React.ReactElement {
  return <ChakraList {...props} />;
}
